export const TOOL_MAP = [
  {
    name: '画笔',
    tool: 'brush',
    icon: 'canvas-brush',
    canCheck: true,
  },
  {
    name: '橡皮',
    tool: 'rubber',
    icon: 'canvas-rubber',
    canCheck: true,
  },
  {
    name: '文本',
    tool: 'text',
    icon: 'canvas-text',
    canCheck: true,
  },
  {
    name: '批注',
    tool: 'note',
    icon: 'canvas-note',
    canCheck: true,
  },
  {
    name: '清除',
    tool: 'clean',
    icon: 'canvas-clean',
    canCheck: false,
  },
  {
    name: '保存',
    tool: 'save',
    icon: 'canvas-save',
    canCheck: false,
  },
  {
    name: '保存学程',
    tool: 'save-course',
    icon: 'canvas-save-course',
    canCheck: false,
  },
]
